import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import { ListDivider } from '@ipfabric/ui-components/List/ListDivider/ListDivider';
import type { FC } from 'react';

export const NoSnapshots: FC<{
  variant: 'no-results' | 'no-snapshots-yet';
}> = ({ variant }) => (
  <>
    <ListDivider />
    <div className='p-8 flex flex-col items-center justify-center gap-3xs'>
      <div className='flex gap-3xs'>
        <Icon
          glyph={variant === 'no-results' ? 'fa-search' : 'fa-file-slash'}
        />
        <span className='text-base font-semibold text text-plain'>
          {variant === 'no-results' ? 'No results' : 'No snapshots yet'}
        </span>
      </div>
      <div className='text-xs text-plain'>
        {variant === 'no-results'
          ? 'We can’t find any snapshot matching your search'
          : 'You can start a discovery to create new snapshot'}
      </div>
    </div>
  </>
);
